module.exports = __webpack_public_path__ + "static/media/logo.610b76cd.png";